import {UUID} from '../../../shared/types/uuid.type';
import {createAction, props} from '@ngrx/store';

const prefix = '[DeleteManyProductionInstances] ';

export const deleteManyProductionInstances = createAction(
  `${prefix} Delete Many Production Instances`,
  props<{ ids: UUID[] }>()
);

export const deleteManyProductionInstancesSuccess = createAction(
  `${prefix} Delete Many Production Instances Success`,
  props<{ ids: UUID[] }>()
);

export const deleteManyProductionInstancesFailure = createAction(
  `${prefix} Delete Many Production Instances Failure`,
  props<{ error: any }>()
);

export const clearDeleteManyProductionInstancesState = createAction(
  `${prefix} Clear Delete Many Production Instances State`
);
